import DOMPurify from "dompurify";

const DEFAULT_CONFIG = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ["target", "rel", "id"],
  FORBID_TAGS: ["style", "iframe", "object", "embed", "form", "input", "button"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "style"],
};

/**
 * Sanitize untrusted HTML before rendering with dangerouslySetInnerHTML.
 */
export function sanitizeHtml(dirty, config = {}) {
  if (!dirty || typeof dirty !== "string") return "";
  return DOMPurify.sanitize(dirty, { ...DEFAULT_CONFIG, ...config });
}
